export default "__VITE_ASSET__DltQ_1Ai__"